import PubSub from 'pubsub-js';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const mediaRow = {
  init() {
    this.$mediaRows = document.querySelectorAll('section.media_row .thumbnail');
    this.$modal = document.getElementById('modal');

    if (this.$mediaRows && this.$mediaRows.length) {
      console.log('Media rows init!');

      this.destroyBinded = this.destroy.bind(this);
      this.clickHandlerBinded = this.clickHandler.bind(this);
      this.closeBinded = this.close.bind(this);
      this.setUpListeners();
    }
  },

  setUpListeners() {
    PubSub.subscribe('page.transitionMiddle', this.destroyBinded);

    this.$mediaRows
      .forEach($row => $row.addEventListener('click', this.clickHandlerBinded));

    this.$modal
      .addEventListener('click', this.closeBinded);
  },

  clickHandler(ev) {
    const $parent = ev.currentTarget.closest('.item_wrapper');
    const $iframe = $parent.querySelector('iframe').cloneNode(true);

    this.$modal
      .querySelector('.content')
      .appendChild($iframe);

    this.$modal.classList.add('active');
  },

  close(ev) {
    if (ev.target.closest('.close') || ev.target.classList.contains('modal')) {
      this.$modal.querySelector('.content').innerHTML = '';
      this.$modal.classList.remove('active');
    }
  },

  destroy() {
    console.log('Destroy: media rows module');


    this.$mediaRows
      .forEach($row => $row.removeEventListener('click', this.clickHandlerBinded));

    this.$modal
      .querySelector('.close')
      .removeEventListener('click', this.closeBinded);

    PubSub.unsubscribe('page.transitionMiddle', this.destroyBinded);
  }
};

PubSub.subscribe('page.inDOM', mediaRow.init.bind(mediaRow));

export default mediaRow;
